import { useQuery } from '@tanstack/react-query';
import { useConnection } from 'wagmi';

import { QueryKeys } from '@/app/shared/constants/queryKeys';
import { getReferralSummary } from '@/app/shared/services/api';
import { ReferralSummaryResponse } from '@/app/shared/services/api/types';

export interface UseReferralSummaryReturn {
  summary: ReferralSummaryResponse | null;
  code: string | null;
  referredByCode: string | null;
  invitedUsers: number;
  activeInvitees: number;
  inviteeActiveBoost: string | null;
  referrerTotalEarned: string | null;
  isLoading: boolean;
  refetch: () => void;
}

export const useReferralSummary = (): UseReferralSummaryReturn => {
  const { address } = useConnection();

  const { data, isLoading, refetch } = useQuery({
    queryKey: [QueryKeys.REFERRAL_SUMMARY, address],
    queryFn: () => getReferralSummary(address),
    enabled: !!address,
  });

  return {
    summary: data ?? null,
    code: data?.code ?? null,
    referredByCode: data?.referredBy?.code ?? null,
    invitedUsers: data?.stats.invitedUsers ?? 0,
    activeInvitees: data?.stats.activeInvitees ?? 0,
    inviteeActiveBoost: data?.stats.inviteeActiveBoost ?? null,
    referrerTotalEarned: data?.stats.referrerTotalEarned ?? null,
    isLoading,
    refetch,
  };
};
